var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 10,
    viewBox: "0 0 21 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1133 5.72235C20.3463 5.48932 20.3463 5.11151 20.1133 4.87848L16.3159 1.08105C16.0828 0.848025 15.705 0.848025 15.472 1.08105C15.239 1.31408 15.239 1.6919 15.472 1.92493L18.8475 5.30042L15.472 8.6759C15.239 8.90893 15.239 9.28675 15.472 9.51978C15.705 9.75281 16.0828 9.75281 16.3159 9.51978L20.1133 5.72235ZM0 5.30042V5.89712H19.6914V5.30042V4.70371H0V5.30042Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.d911f047758ca08403be90e84ca8414f.svg";
export { ForwardRef as ReactComponent };